import api from "./axios"; 

export async function createCustomCategory({ userId, descricao }) {
  const response = await api.post("/custom-category", {
    userId,
    descricao,
  });

  return response.data;
}

export async function getCustomCategories(userId) {
  const response = await api.get(`/custom-category/${userId}`);
  return response.data; // array de categorias
}
 
 
export async function deleteCustomCategory(categoryId, userId) {
  const response = await api.delete(`/custom-category/${categoryId}`, {
    data: { userId },
  });

  return response.data;
}
